import { createConsumer } from '@rails/actioncable';
import './signature_channel';
import './summary_channel';
import './ping_channel';
import './export_channel';

export default createConsumer();
